<template>
      <v-col>
          <v-card flat>
         <v-data-table
            :key="componentKey"
            :headers="computedHeaders"
            :items="tableItems"
            class="elevation-1"
            :loading="paymentsLoadStatus===1"
            :options.sync="tableOptions"
            :server-items-length="options.lineCount"
            hide-default-footer
            must-sort
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Raport kasowy</v-toolbar-title>
                
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                 <v-menu
                                      v-model="selectedDayMenu"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="150px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          v-model="selectedDay"
                                          clearable
                                          label="Data"
                                          prepend-icon="mdi-calendar"
                                          readonly
                                          v-on="on"
                                          class="choose_date mt-6 mr-5"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker first-day-of-week="1" v-model="selectedDay" @input="selectedDayMenu = false"></v-date-picker>
                </v-menu>
               
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Wyszukaj"
                      single-line
                      hide-details
                      class="search"
                      @keydown.enter="searchPayments"
                  ></v-text-field>
                  </template>
                    <span>Wpisz min 3 znaki i naciśnij Enter</span>
                </v-tooltip>
                 

                <v-spacer></v-spacer>

                <v-checkbox v-model="showDeleted" class="mt-4" label="Pokaż wyłączone"></v-checkbox>

                <v-divider
                  v-if="user.permissions['payment'] >= 10"
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
               <v-dialog v-if="user.permissions['payment'] >= 10" v-model="dialog" max-width="900px">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="addItem" small class="mb-2 mt-2" fab dark color="primary">
                      <v-icon dark>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <v-card  :loading="paymentAddStatus===1 || paymentEditLoadStatus===1 || paymentEditStatus===1">
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        
                           <v-row>                   
                            <v-col class="col-6">
                                <v-card flat class="elevation-1 pb-2"  style="background-color: #f4f4f4;">
                                <v-toolbar flat  dense style="background-color: #f4f4f4;">
                                    <v-toolbar-title>Raport kasowy</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-title><b>{{editedItem.date}}</b></v-toolbar-title>
                                </v-toolbar>
                                    <v-text-field 
                                    v-if="itemViewing || itemEditing || paymentEditing"
                                    v-model="editedItem.document_number" 
                                    readonly 
                                    hide-details 
                                    class="ml-4 mr-4" 
                                    ></v-text-field>

                                <h4 v-if="itemViewing || itemEditing || paymentEditing" class="mt-2 mr-4 text-end">{{editedItem.created_at}} / {{editedItem.created_by}}</h4>
                              </v-card>
                            </v-col>
                          </v-row>


                          <v-row>
                            <v-col class="col-12">
                               <v-card flat class="elevation-1">
                                <v-data-table
                                  :headers="headersDocuments"
                                  :items="tableDocuments"
                                  class="elevation-0"
                                  item-key="id"
                                  dense
                                  hide-default-footer
                                  disable-pagination
                                  sort-by="month"
                                  style="background-color: #f4f4f4;"
                                >

                                  <template v-slot:top>
                                    <v-toolbar flat style="background-color: #f4f4f4;" dense>
                                      <v-toolbar-title>Pozycje dokumentu</v-toolbar-title>
                                    </v-toolbar>
                                  </template>
                                 
                                  <!-- <template v-if="editedItem.type=='KP'" v-slot:item.amount="{ item }">
                                    {{ $n(item.amount-item.posted_without_document, 'currency', 'pl-PL') }}
                                  </template> -->
                                  <template v-slot:item.child="{ item }">
                                    {{item.child.name+' '+item.child.surname}}
                                  </template>

                                  <template v-slot:item.amountKP="{ item }">
                                    <template>{{ $n(item.amountKP, 'currency', 'pl-PL') }}</template>
                                  </template>

                                  <template v-slot:item.amountKW="{ item }">
                                    <template>{{ $n(item.amountKW, 'currency', 'pl-PL') }}</template>
                                  </template>

                                   <template v-if="tableDocuments.length>0" slot="body.append">
                                      <tr class="v-data-table__selected font-weight-medium subheading">
                                              <td></td><td></td>
                                              <td>Suma</td>
                                              <td>{{$n(sumField('amountKP'), 'currency', 'pl-PL')}}</td>
                                              <td>{{$n(sumField('amountKW'), 'currency', 'pl-PL')}}</td>
                                      </tr>
                                  </template>
                                </v-data-table>
                              </v-card>
                            </v-col>
                          </v-row>
                          <v-row  v-if="tableDocuments.length>0">            
                            <v-col class="col-8"></v-col>       
                            <v-col class="col-4">
                                <v-card flat class="elevation-1 pb-2"  style="background-color: #f4f4f4;">
                                <v-toolbar flat  dense style="background-color: #f4f4f4;">
                                    <v-toolbar-title>Saldo</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-title><b>{{$n(sumField('amountKP')-sumField('amountKW'), 'currency', 'pl-PL')}}</b></v-toolbar-title>
                                </v-toolbar>
                                </v-card>
                            </v-col>
                          </v-row>
                          <v-row v-if="paymentEditLoadStatus===3">
                                    <v-col class="d-flex flex-column align-center">
                                        <v-alert dense outlined type="error">
                                          {{paymentEditText}}
                                        </v-alert>    
                                    </v-col>
                            </v-row> 
                      </v-container>
                    </v-card-text>

                    

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="gray" text @click="close">{{itemViewing || paymentEditing || paymentEditLoadStatus==3?'Zamknij':'Anuluj'}}</v-btn>
                      <v-btn  color="primary darken-1" text @click="handleSubmit" v-if="!itemViewing && !itemEditing && !paymentEditing && paymentEditLoadStatus!=3" >Zatwierdź</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>

            <template  v-slot:item.amount="{ item }">
                {{ $n(item.amount, 'currency', 'pl-PL') }}
             </template>

            <template v-slot:item.status2="{ item }">
              {{item.status}}
            </template>

            <template v-slot:item.actions="{ item }">
                <!-- <v-tooltip v-if="item.can_delete && user.permissions['payment'] >= 10" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class="mr-2"
                    @click="editItem(item)"
                  >
                    mdi-pencil
                  </v-icon>
                  </template>
                    <span>Edytuj</span>
                </v-tooltip> -->

                <v-tooltip v-if="item.active && item.can_delete && user.permissions['payment'] >= 10" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class="mr-2"
                    @click="deleteItem(item)"
                  >
                    mdi-delete
                  </v-icon>
                  </template>
                  <span>Wyłącz</span>
                </v-tooltip>

                <v-btn @click="viewItem(item)" v-if="item.active && user.permissions['payment'] >= 5"   color="primary" x-small>Podgląd</v-btn>
             
                
            </template> 

            <template v-slot:item.status="{ item }">
              <v-simple-checkbox v-model="item.active" disabled></v-simple-checkbox>
            </template>



          </v-data-table> 
          <div class="text-center pt-2">
            <v-btn @click="loadMore" v-if="!options.itemAdded && options.lineCount-tableItems.length>0 && paymentsLoadStatus===2" small color="primary"><v-icon left>mdi-download</v-icon>Załaduj więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadPayments" v-else-if="options.itemAdded && options.lineCount-tableItems.length>0" small color="primary"><v-icon left>mdi-reload</v-icon>Odśwież tabele aby móc załadować więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadPayments" v-else-if="options.itemSearched" small color="primary"><v-icon left>mdi-reload</v-icon>Anuluj wyszukiwanie</v-btn>
          
          </div>

          </v-card>
      
      <confirm ref="confirm"></confirm>
      </v-col>
      

</template>

<script>
  import Vue from 'vue'
  import confirm from '../components/Confirm'

  export default {
    components:{
      confirm
    },
    data: () => ({
      componentKey:0,
      tableOptions: {},
      selectedDayMenu:false,
      dialog: false,
      itemEditing:false,
      itemViewing:false,
      search:'',
      headers: [
        { text: '',align: 'start',sortable: false,value: 'lp',filterable:false,display:true},
        { text: 'Data', value: 'date',filterable:false,filterColumn:"date",display:true },
        { text: 'Nr dokumentu', value: 'document_number',filterable:true,filterColumn:"number",display:true },
        { text: 'Kwota', value: 'amount',filterable:true,filterColumn:"amount",display:true },
        { text: 'Status', value: 'status2',filterable:false,display:true },
        { text: 'Zatwierdził', value: 'created_by',filterable:true,display:true,filterColumn:"created_by" },
        { text: 'Aktywne', value: 'status',filterable:false,sortable: false,display:true },
        { text: 'Akcje', value: 'actions', sortable: false,filterable:false,display:true },
      ],
      headersDocuments: [
        { text: '',align: 'start',value: 'lp'},
        { text: 'Nr dokumentu', value: 'document_number' },
        { text: 'Dziecko', value: 'child'},
        { text: 'Kwota wpłaty', value: 'amountKP'},
        { text: 'Kwota wypłaty', value: 'amountKW'},
      ],
    }),
    watch: {
      tableOptions: {
        handler () {
          var currentOptions = {...this.options};
          const { sortBy, sortDesc } = this.tableOptions
        
          //zmiana sortowania
          if (sortBy.length === 1 && sortDesc.length === 1) {
            currentOptions.orderBy = Vue._.find(this.headers,{'value':sortBy[0]}).filterColumn;
            currentOptions.orderDirection = sortDesc[0]?'desc':'asc';
            this.options = currentOptions;
          } 
        },
        deep: true,
      },
      dialog (val) {
        val || this.close()
      },
      paymentEditStatus(val){
        if(val===2){
          //this.close();
          //this.componentKey += 1;
        }
      },
      paymentAddStatus(val){
        if(val===2){
          //this.close();
          //this.componentKey += 1;
        }
      },
      paymentDeleteStatus(val){
        if(val===2){
          this.componentKey += 1;
        }
      }
    },
    computed: {
      user(){
        return this.$store.getters.getUser;
      },
      lookups(){
        return this.$store.getters.getLookups;
      },
      options:{
        get () {  
          return this.$store.getters.getPaymentOptions;
        },
        set (value) {
          this.search='';
          this.$store.dispatch( 'setPaymentOptions', {options:value} )
        }
      },
      selectedDay:{
        get () {
          return this.$store.getters.getPaymentOptions.selectedDay;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.selectedDay = value;
          this.options = currentOptions;
          //this.$store.dispatch( 'loadCourseLookup', {year_id:this.options.selectedCourse} );
        }
      },
      showDeleted: {
        get () {
          return this.$store.getters.getPaymentOptions.showDeleted;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.showDeleted = value;
          this.options = currentOptions;
        }
      },
      editedItem(){
        return this.$store.getters.getPaymentEdit;
      },
      tableItems(){
        return this.$store.getters.getPayments;
      },
      tableDocuments(){
        return this.editedItem.documents;
      },
      paymentsLoadStatus(){
        return this.$store.getters.getPaymentsLoadStatus;
      },
      paymentEditLoadStatus(){
        return this.$store.getters.getPaymentEditLoadStatus
      },
      paymentEditStatus(){
        return this.$store.getters.getPaymentEditStatus();
      },
      paymentEditText(){
        return this.$store.getters.getPaymentEditText
      },
      paymentEditing(){
        return this.$store.getters.getPaymentEditing;
      },
      paymentAddStatus(){
        return this.$store.getters.getPaymentAddStatus();
      },
      paymentAddText(){
        return this.$store.getters.getPaymentAddText;
      },
      paymentDeleteStatus(){
        return this.$store.getters.getPaymentDeleteStatus();
      },
      settlementsLoadStatus(){
        return this.$store.getters.getSettlementsLoadStatus;
      },
      computedHeaders () {
        var localHeaders = [...this.headers.filter(h => h.display===true)]
        if(!this.showDeleted && this.user.permissions['payment'] <= 5) return localHeaders.filter(h => h.value!=='status' && h.value!=='actions')
        else if(this.showDeleted && this.user.permissions['payment'] <= 5) return localHeaders.filter(h => h.value!=='actions')
        else if(!this.showDeleted) return localHeaders.filter(h => h.value!=='status')
        else return localHeaders
      },
      formTitle () {
        if(this.itemViewing || this.paymentEditing)return 'Podgląd dokumentu'
        return 'Nowy dokument'
      },
    },
    mounted(){
      if(this.lookups.years.length>0){
        this.loadPayments();
      }else{
        this.$store.dispatch( 'loadLookups' );
        setTimeout(() => {
          this.loadPayments();
        }, 2000)
      }
    },
    methods: {
      loadPayments(){
        this.search='';
        var currentOptions = {...this.$store.getters.getPaymentOptions};
        var date = new Date(); 
        currentOptions.orderBy = 'date';
        currentOptions.orderDirection = 'desc';
        currentOptions.selectedDay = undefined;
        currentOptions.selectedType=['RK'];
        this.$store.dispatch( 'setPaymentOptions', {options:currentOptions} )
      },
      loadMore(){
        this.$store.dispatch( 'loadMorePayments' );
      },
      addItem(){
        this.$store.dispatch( 'loadDocumentsForDay' );
      },
      editItem (item) {
        this.itemEditing = true
        this.itemViewing = false
        this.$store.dispatch( 'loadDocumentEdit', {slug:  item.id});  
        //this.$store.dispatch( 'loadSettlementsForChild', {child_id:item.child.id});
        this.dialog = true
      },
       viewItem (item) {
        this.itemEditing = false
        this.itemViewing = true
        this.$store.dispatch( 'loadDocumentEdit', {slug:  item.id});  
        this.dialog = true
      },
      monthName(val){
        return Vue._.find(this.lookups.months, {'value':val}).text;
      },
      deleteItem (item) {
        this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz usunąć dokument?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'deleteDocument', {slug:  item.id});
            }
        })
      },
      searchPayments(){
        if(this.search.length>2){
          const filterableHeaders = _.join(_.map(_.filter(this.headers,{'filterable':true}),'filterColumn'),';');
          this.$store.dispatch( 'searchPayments',{filterableHeaders:filterableHeaders,q:this.search.replace(/,/, ".")});
        }
      },
      close () {
        this.dialog = false
        this.componentKey += 1;
        this.searchReference = null
        this.selectedSettlements = []
        this.selectedSelected = []
        setTimeout(() => {
          this.$store.dispatch( 'loadPaymentEditDefault'); 
          this.$store.dispatch( 'loadPaymentAddDefault');
          this.itemEditing = false
          this.itemViewing = false
        }, 300)
      },
       sumField(key) {
        return this.tableDocuments.reduce((a, b) => a + ((b && b[key])?b[key]:0 || 0), 0);
      },
     handleSubmit () {
             if (this.itemEditing) {
                // this.$store.dispatch( 'editDocument', {
                //   slug: this.editedItem.id,
                //   type:  'RK',
                //   amount: this.editedItem.amount.toString().replace(/\./g, "").replace(/,/, "."),
                //   selected: Vue._.map(this.editedItem.selected,function (s) {return {id:s.id,payed:s.payed}}),
                // });
             } else {//new item
                this.$store.dispatch( 'addDocument', {
                  type:  'RK',
                  amount: this.sumField('amountKP')-this.sumField('amountKW'),
                  selected: Vue._.map(this.editedItem.documents,function (s) {return s.id}),
                  date:this.editedItem.date
                });
             }
       },
    },
  }
</script>


<style scoped>
.search{
      max-width: 200px;
}
.choose_date{
      max-width: 150px;
}
</style>